import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import {
  GetOrganizationsAndTutorsOfCompanyOwner,
  GetTutorsOfOrganization,
} from '../helper/apiHelper';

export const useTutorsOfOrganization = (organizationId: string | number) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.TUTORS_OF_ORGANIZATIONS, Number(organizationId)],
    queryFn: async () => {
      return await GetTutorsOfOrganization(String(organizationId));
    },
    enabled: !!organizationId,
  });
};

export const useOrganizationsAndTutorsOfOrganizationOwner = (
  organizationOwnerId: string | number
) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS_TUTORS, organizationOwnerId],
    queryFn: () => GetOrganizationsAndTutorsOfCompanyOwner(organizationOwnerId),
  });
};
